import {
  getOffPlatformReceivablesListAPI,
  OffPlatformReceivableResponse
} from "services/api/offPlatformReceivables";
import saveCsvFile from "helpers/saveCsvFile";
import type { ReceivablesListFilters } from "./ReceivablesList";

const CSV_HEADER = "invoice_number,load_number,paid_amount,close_invoice,date_paid,payment_number";
const EXPORT_PAGE_SIZE = 100;
const CSV_FILENAME = "off_platform_receivables.csv";

const escapeCsvValue = (value: string) => {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const fetchAllFilteredReceivables = async ({ search, statuses }: ReceivablesListFilters) => {
  const rows: OffPlatformReceivableResponse[] = [];
  let offset = 0;
  let count = 0;

  do {
    const response = await getOffPlatformReceivablesListAPI({
      limit: EXPORT_PAGE_SIZE,
      offset,
      search: search || undefined,
      status: statuses.join(",") || undefined
    });
    if (!response.data.results.length) {
      break;
    }
    rows.push(...response.data.results);
    count = response.data.count;
    offset += EXPORT_PAGE_SIZE;
  } while (rows.length < count);

  return rows;
};

export default async function downloadReceivablesCsv(filters: ReceivablesListFilters) {
  const rows = await fetchAllFilteredReceivables(filters);
  const lines = rows.map((row) =>
    [
      escapeCsvValue(row.invoice_number || ""),
      escapeCsvValue(row.load_number || ""),
      "",
      "",
      "",
      ""
    ].join(",")
  );
  const csv = [CSV_HEADER, ...lines].join("\n");

  await saveCsvFile(`${csv}\n`, CSV_FILENAME);
}
